package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.arenaproplay.admin.ui.utils.sBorderRadius
import org.jetbrains.compose.web.css.px
import kotlin.math.abs
import kotlin.math.roundToInt

/**
 * Night Arena trend pill — the ▲/▼ delta badge next to a hero number
 * («▲ +12%»): solid mint pill with near-black text when the trend is good,
 * solid coral when it is bad.
 *
 * @param deltaPercent delta vs the previous period, in percent (12.0 → +12%).
 *        `null` renders nothing.
 * @param goodWhenUp   set false for metrics where a drop is good (churn, CAC).
 */
@Composable
fun TrendPill(
    deltaPercent: Double?,
    goodWhenUp: Boolean = true,
    modifier: Modifier = Modifier
) {
    if (deltaPercent == null) return

    val up = deltaPercent >= 0
    val good = up == goodWhenUp
    val arrow = if (up) "▲" else "▼"
    val magnitude = abs(deltaPercent)
    val number =
        if (magnitude >= 10) "${magnitude.roundToInt()}"
        else {
            val oneDecimal = (magnitude * 10).roundToInt() / 10.0
            if (oneDecimal == oneDecimal.roundToInt().toDouble()) "${oneDecimal.roundToInt()}"
            else "$oneDecimal"
        }
    val sign = if (up) "+" else "−"
    val bg = if (good) "#00E5A4" else "#FF6B5B"
    val fg = if (good) "#03140B" else "#230B07"

    Box(
        modifier
            .padding(leftRight = 10.px, topBottom = 3.px)
            .sBorderRadius(999)
            .styleModifier {
                property("background", bg)
                property("white-space", "nowrap")
            }
    ) {
        SpanText(
            "$arrow $sign$number%",
            Modifier.styleModifier {
                property("font-size", "12px")
                property("font-weight", "700")
                property("color", fg)
                property("font-feature-settings", "\"tnum\" 1")
                property("font-variant-numeric", "tabular-nums")
            }
        )
    }
}
